import React from 'react';
import $ from 'jquery';
import ReactTooltip from 'react-tooltip';
import Axios from 'axios';
import { API_HOST, axiosInstance, axiosRequestWithAuth } from '../../constants/server.constant';
import ResourceService from '../../services/resource.service';
import SessionService from '../../services/session.service';
import { loginService } from '../../services/login.service';
import CommonMessage from '../common/commonMessage';
import { userService } from '../../services/user.service';

class TwoFaOtpDeactivate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            email: localStorage.getItem('email'),
            password: '',
            userId: localStorage.getItem('userId'),
            message: '',
            msgType: '',
        };

    }

    componentDidMount() {
        ResourceService.getPageInfo().then(resp => {
            if(resp && resp !== '') {
                if(!resp.includes('2fa-verification?ty=3')) {
                    this.topBackbttnClick();
                }
            }
        });
    }

    topBackbttnClick() {
        loginService.redirectToLogin();
        //this.props.history.push('/login')
    }

    deactivateTotp() {
        if(this.state.password === undefined || this.state.password.trim() === '') {
            this.setState({ paswdErrorMessg: 'Password cannot be blank' });
            return;
        }
        if(this.state.recoveryCode === undefined || this.state.recoveryCode.trim() === '') {
            this.setState({ recoveryErrorMessg: 'Recovery code cannot be blank' });
            return;
        }
        if(this.state.recoveryCode.trim().length < 16) {
            this.setState({ recoveryErrorMessg: 'Code should be of 16 characters' });
            return;
        }
        let reqBody = {
            email: this.state.email,
            password: this.state.password.trim()
        };
        Axios.post(API_HOST + `/2fa/totp/auth-deactivate/` + this.state.recoveryCode, reqBody, axiosRequestWithAuth).then(resp => {
            let state = { from2faDeactivate: true };
            if(resp?.data?.emailTransfer) state.emailTransfer = resp.data.emailTransfer;
            userService.getUser().then((response) => {
                loginService.setUserLocal(response, true);
                let redirectUrl = SessionService.getCookie("_redirect_url");
                if(typeof redirectUrl !== 'undefined') {
                    this.props.history.push({ pathname: redirectUrl, state: state });
                    loginService.deleteCookie("_redirect_url", "/app");
                } else {
                    this.props.history.push({ pathname: '/account/security', state: state });
                }
            }).catch((error) => {
                console.error("Error while fetching user details after two-fa deactivation ...");
                loginService.redirectToLogin();
            });
        }).catch(error => {
            if(error?.response?.status === 403) {
                console.log(error?.response);
                if(error?.response?.data === `Invalid Recovery Code`) {
                    this.setState({ recoveryErrorMessg: 'Invalid Recovery Code' });
                    return;
                } else {
                    this.setState({ paswdErrorMessg: 'Invalid Password' });
                    return;
                }
            } else {
                this.setState({ message: error?.response?.data, msgType: "error" });
                return;
            }
        });
    }

    onKeyDownDeact(e, name) {
        if(e.keyCode === 13) {
            if(name === 'password' || name === 'recover') {
                this.deactivateTotp();
            }
        }
    }

    inputChangeHandler = (event) => {
        let name = event.target.name;
        let val = event.target.type === 'checkbox' ? event.target.checked : event.target.value;

        this.setState({ [name]: val, recoveryErrorMessg: '', paswdErrorMessg: '' });
    };
    redirectToIndex() {
        window.location = "https://www.idrivecompute.com/index.html";
    }
    render() {
        return (
            <body className="idcmp-frontend-main">
                <header>
                    <div className="idcmp-2fa-container">
                        <a href="#" className="back_btn" data-tip data-for="back" onClick={ (e) => { this.topBackbttnClick(); e.preventDefault(); } }>
                            <span >
                                <svg x="0px" y="0px" width="50px" height="30px" viewBox="0 0 50 30" enableBackground="new 0 0 50 30" xmlSpace="preserve">
                                    <g>
                                        <path fill="#F3F3F3" d="M49,3.01v23.98C49,28.1,48.1,29,47,29H3c-1.1,0-2-0.9-2-2.01V3.01C1,1.9,1.9,1,3,1h44
                            C48.1,1,49,1.9,49,3.01z"></path>
                                        <path fill="#CCCCCB" d="M47,0H3C1.34,0,0,1.35,0,3.01v23.98C0,28.65,1.34,30,3,30h44c1.66,0,3-1.35,3-3.01V3.01
                            C50,1.35,48.66,0,47,0z M49,26.99C49,28.1,48.1,29,47,29H3c-1.1,0-2-0.9-2-2.01V3.01C1,1.9,1.9,1,3,1h44c1.1,0,2,0.9,2,2.01V26.99z
                            "></path>
                                    </g>
                                    <polygon fill="#636363" points="33,10 33,15.99 23,16 23,21 17,15 23,9 23,14 31,14 31,10 "></polygon>
                                </svg>
                            </span>
                        </a><ReactTooltip id="back" place="right" effect="solid">Back to login</ReactTooltip>
                        <div className="idcmp-logo" onClick={ () => this.redirectToIndex() }>
                            <a href="#" onClick={ (e) => e.preventDefault() }><img src="https://www.idrivecompute.com/webapp/images/computelogo_blue.svg" alt="IDrive Compute Logo" /></a>
                        </div>
                    </div>
                </header>
                <CommonMessage message={ this.state.message } handler={ () => this.setState({ message: '' }) } msgType={ this.state.msgType } />
                <div className="idcmp-2fa-wrpr">
                    <div className="idcmp-2fa-blk">
                        <h1 className="idcmp-2fa-title">Deactivate Time-based OTP authentication</h1>
                        <p className="idcmp-2fa-content">  If you have lost access to your mobile device where the Time-based OTP Authenticator app is installed, you can disable two-factor authentication via Time-based OTP authentication by entering your 16-digit recovery code.</p>

                        <div className="idcmp-2fa-code-blk">
                            <div className="idcmp-form-grp">
                                <div className="idcmp-form-row">
                                    <label >Email Address</label>
                                    <input type="text" className="idcmp-frm-ctrl disabled" name="email" value={ this.state.email } disabled={ true } />
                                </div>
                                <div className="idcmp-form-row">
                                    <label >Password</label>
                                    <input type="password" className="idcmp-frm-ctrl" name="password" value={ this.state.password } onChange={ (e) => this.inputChangeHandler(e) } onKeyDown={ (e) => this.onKeyDownDeact(e, 'password') } />
                                    <span className="idcmp-err-inp" > { this.state.paswdErrorMessg } </span>
                                </div>
                                <div className="idcmp-form-row">
                                    <label ><span>Recovery Code</span>
                                        <span className="question_icon active" data-tip data-for="recTool" >
                                            <svg x="0px" y="0px" viewBox="0 0 22 20" enableBackground="new 0 0 22 20" xmlSpace="preserve">
                                                <path fillRule="evenodd" clipRule="evenodd" fill="#89A2BE" d="M11,1c5,0,9,4,9,9s-4,9-9,9c-5,0-9-4-9-9S6,1,11,1z"></path>
                                                <text transform="matrix(1 0 0 1 7.0724 15.4681)" fill="#FFFFFF" fontFamily="'Roboto-Medium'" fontSize="14px">?</text>
                                            </svg>
                                        </span>
                                        <ReactTooltip id="recTool" effect="solid" place="top">Enter the recovery code for your<br /> TOTP authenticator app that you<br /> have received while activating two-<br />step verification for your account.</ReactTooltip>

                                    </label>
                                    <input type="text" className="idcmp-frm-ctrl" name="recoveryCode" onChange={ (e) => this.inputChangeHandler(e) } value={ this.state.recoveryCode } maxLength="16" onKeyDown={ (e) => this.onKeyDownDeact(e, 'recover') } />
                                    <span className="idcmp-err-inp"> { this.state.recoveryErrorMessg } </span>

                                </div>
                                <input type="submit" className="idcmp-btn idcmp-primary-btn" value="Deactivate" onClick={ () => this.deactivateTotp() } />
                                <input type="submit" className="idcmp-btn" value="Cancel" onClick={ () => this.props.history.push('2fa-verification?ty=3') } />
                            </div>
                        </div>
                    </div>
                </div>
                <footer>
                    <p className="idcmp-copy">© IDrive Inc.</p>
                </footer>
            </body>
        );
    }
}
export default TwoFaOtpDeactivate;